import genericStore from "../generic_store";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "faqs",
    object: "faq",
    header: [
      // { text: "ID", value: "id" },
      { text: "Question", value: "question" },
      { text: "Answer", value: "answer" },
      { text: "Type", value: "type" },
      { text: "Actions", value: "actions", sortable: false },
    ],
  },
  mutations: {
    ...genericStore.mutations,
  },
  actions: {
    ...genericStore.actions,
  },
  getters: {
    ...genericStore.getters,
  },
};
